import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import SupportAccessPreview from "../../../../components/SupportAccessPreview";

const OrganizationSupportAccessIndexPage = () => {
	const { t } = useTranslation();
	const { handleChangeTabTitle } = useBrowserTabTitle();

	useEffect(() => {
		handleChangeTabTitle(t("modules.support_access.header.title"));
	}, []);

	return <SupportAccessPreview title={t("modules.support_access.header.title")} />;
};

export default OrganizationSupportAccessIndexPage;
